export const siteConfig = {
  name: "Edil Ozi",
  url: "https://edilozi.pro",
  ogImage: "https://edilozi.pro/og.jpg",
  description: "Open Source components for React.js that you can seamlessly integrate into your projects",
  links: {
    edilozi: "https://edilozi.pro",
    github: "https://github.com/Edil-ozi/edil-ozi",
  },
};

export type SiteConfig = typeof siteConfig;
